import React from "react"
import { useSelector, useDispatch } from 'react-redux'
import gameActions from '../../store/actions/gameActions'
import Button from '../Button'

const Choices = ({ choices }) => {
  const dispatch = useDispatch()
  const gameState = useSelector(state => state.game)

  return (
    <div className='flex justify-end'>
      {choices.map((choice, index) => {
        return (
          <Button
            key={choice.index}
            disabled={gameState.isAdvanceButtonLocked}
            className={index < choices.length - 1 ? 'mr-4 my-2' : 'mr-0 my-2'}
            onClick={(ev) => {
              if (gameState.isInMinigame && gameState.isAdvanceButtonLocked) {
                dispatch(gameActions.finishMiniGame())
                dispatch(gameActions.makeChoice(gameState.narrative, gameState.chapter, choice.index, ev.target.textContent))
              } else {
                dispatch(gameActions.makeChoice(gameState.narrative, gameState.chapter, choice.index, ev.target.textContent))
              }
            }}
          >
            {choice.text}
          </Button>
        )
      })}
    </div>
  )
}

export default Choices;